/**
 * Scavenging: what you leave with.
 */

import type { PerkBranch } from '@/sim/progression/perkBranchContract';

export const SCAVENGING_BRANCH = {
  id: 'scavenging',
  title: 'Scavenging',
  blurb: 'Wartime thrift, in a war that is technically over.',
} as const satisfies PerkBranch;
